import { render, staticRenderFns } from "./HistoryData.vue?vue&type=template&id=1bb63747&scoped=true"
import script from "./HistoryData.vue?vue&type=script&lang=ts"
export * from "./HistoryData.vue?vue&type=script&lang=ts"
import style0 from "./HistoryData.vue?vue&type=style&index=0&id=1bb63747&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb63747",
  null
  
)

export default component.exports